import { render, staticRenderFns } from "./accountDetail.vue?vue&type=template&id=0f83f8a2"
import script from "./accountDetail.vue?vue&type=script&lang=ts"
export * from "./accountDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports